import { Box, Button, Typography, Grid } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux/es/exports";
import Lightbulb from "../../assets/icons/lightbulb.png";
import Path from "../../assets/icons/path.svg";
import Group1 from "../../assets/icons/Group1.png";
import Group2 from "../../assets/icons/Group2.png";
import "../styles/common.scss";
import {
  updateTabStatus,
  updateFtTabStatus,
} from "../../services/yourAssets/CommonServices";
import { updateSBText } from "../../utils/suggestionBoxUtilities";
import { updateSBTextStatus } from "../../utils/statusViewUtilities";
import { flexbox } from "@mui/system";
import { getUserIdFromLocalStorage } from "../../utils/Utilities";
import { useTranslation } from "react-i18next";
const SuggestionBox = (props) => {
  const { t } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  const { mainText, tabName, setVisited, showBulbIcon = true } = props;
  const [suggestionView, setSuggestionView] = useState(false);
  const [tabID, setTabID] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const currTabIdRef = useRef(tabID);
  const currTabVisitedRef = useRef(suggestionView);
  const dispatch = useDispatch();

  const handleSetVisited = () => {
    dispatch(setVisited(mainText.id));
    setSuggestionView(true);
  };

  useEffect(() => {
    setTabID(mainText?.id || "");
  }, [mainText?.id]);
  useEffect(() => {
    currTabIdRef.current = tabID;
  }, [tabID]);
  useEffect(() => {
    currTabVisitedRef.current = suggestionView;
  }, [suggestionView]);
  useEffect(() => {
    const updateTabTextStatus = async () => {
      if (tabName === "FamilyTree" && mainText?.id && !mainText?.status) {
        await updateFtTabStatus(
          {
            aboutStatusViewId: mainText?.id,
            isVisited: true,
          },
          uID
        );
      } else if (mainText?.id && !mainText?.status) {
        await updateTabStatus(
          {
            aboutStatusViewId: mainText?.id,
            isVisited: true,
          },
          uID
        );
      }
    };
    updateTabTextStatus();
  }, [mainText?.status, props]);

  const stepButtonClick = (direction) => {
    if (direction == "forward") {
      setCurrentStep(currentStep + 1);
    } else {
      setCurrentStep(1);
    }
  };

  const style = {
    fontSize: "13px",
    padding: "0rem 0rem 3rem 0rem",
    color: "#444561",
    lineHeight: "1.2rem",
  };

  return (
    <>
      <Box component="div" className="sugesstion-btn-container">
        <Box component="div" className="relative-container">
          {/* <Box
            className="suggestion-emot"
            component="div"
            width="100px"
            borderRadius="10px"
            boxShadow={3}
            bgcolor="color.magentaLight2"
            padding="0.5rem 1rem"
            textAlign="center"
          >
            <img src="/assets/icons/s-box.png" alt="suggestion" width="30px" />
            <Typography variant="h6" fontSize="13px">
              {t("get-help")}
            </Typography>
          </Box> */}

          {!suggestionView && mainText?.text?.length >= 1 ? (
            <Box className="suggestion-box">
              <Box
                component="div"
                sx={{
                  position: "absolute",
                  top: 0,
                  right: 45,
                  padding: "1rem",
                }}
                onClick={() => {
                  handleSetVisited();
                }}
              >
                <img
                  src={Path}
                  style={{
                    cursor: "pointer",
                  }}
                  alt="arrow"
                />
              </Box>
              <Box component="div" style={style}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: t(mainText?.translationKey, {
                      returnObjects: true,
                    })[currentStep - 1],
                  }}
                />
              </Box>
              {(tabName === "BankBalances" || tabName === "FamilyTree") &&
                mainText?.text?.length > currentStep && (
                  <Box
                    component="div"
                    className="move-btn"
                    sx={{
                      position: "absolute",
                      bottom: "0.7rem",
                      right: "2rem",
                      padding: "1rem",
                    }}
                    onClick={() => {
                      stepButtonClick("forward");
                    }}
                  >
                    <Box
                      component="div"
                      position="relative"
                      width="100%"
                      height="100%"
                    >
                      <img
                        src={Group1}
                        alt="arrow"
                        style={{
                          width: "18px",
                          margin: "0",
                          position: "absolute",
                          top: "50%",
                          transform: "translateY(-50%)",
                        }}
                      />
                    </Box>
                  </Box>
                )}
              {mainText?.text?.length <= currentStep &&
                mainText?.text?.length > 1 && (
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: "0.7rem",
                      right: "2rem",
                      padding: "1rem",
                    }}
                    component="div"
                    className="move-btn"
                    onClick={() => {
                      stepButtonClick("backward");
                    }}
                  >
                    <Box
                      component="div"
                      position="relative"
                      width="100%"
                      height="100%"
                    >
                      <img
                        src={Group2}
                        alt="arrow"
                        style={{
                          width: "18px",
                          margin: "0",
                          position: "absolute",
                          top: "50%",
                          transform: "translateY(-50%)",
                        }}
                      />
                    </Box>
                  </Box>
                )}
            </Box>
          ) : null}

          {suggestionView && showBulbIcon && (
            <Button
              className="suggestion-btn"
              sx={{
                display: "flex",
              }}
              onClick={() => {
                if (mainText) {
                  setSuggestionView(false);
                }
              }}
            >
              <Box component="img" src={Lightbulb} />
            </Button>
          )}
        </Box>
      </Box>
    </>
  );
};

export default SuggestionBox;
